// extracted by mini-css-extract-plugin
module.exports = {"editor":"PromptEditorEditor_editor__m4oJR"};